import React, { useState } from 'react';
import { Grid, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { schedulerService } from '../../../../core/services/schedulerService';
import styles from '../SchedulerSetting.module.scss';

interface CreateTimeOffReasonProps {
	backButtonClick: () => void;
	onTimeOffReasonCreated?: () => void;
}

const CreateTimeOffReason: React.FC<CreateTimeOffReasonProps> = ({
	backButtonClick,
	onTimeOffReasonCreated,
}) => {
	const [reason, setReason] = useState({ 
		name: '', 
		description: '', 
		isPaid: true, 
		requiresApproval: true 
	});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!reason.name.trim()) {
			setError('Time off reason name is required');
			return;
		}

		setIsSubmitting(true);
		setError(null);

		try {
			await schedulerService.addTimeOffReason({
				name: reason.name,
				description: reason.description,
				// isPaid: reason.isPaid,
				// requiresApproval: reason.requiresApproval
			});

			onTimeOffReasonCreated?.();

			// Navigate back after a short delay
			setTimeout(() => {
				backButtonClick();
			}, 1500);
		} catch (err: any) {
			setError(err?.message || 'Failed to create time off reason');
			setIsSubmitting(false);
		}
	};

	return (
		<div className={styles.createTimeOffReason}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<Button className={styles.backButton} onClick={backButtonClick}>
						Back
					</Button>
					<Button className={styles.submitButton} onClick={handleSubmit} disabled={isSubmitting}>
						{isSubmitting ? 'Saving...' : 'Save'}
					</Button>
				</Grid>
				<Grid>
					<h1 className={styles.formTitle}>Create New Time Off Reason</h1>
				</Grid>
			</Grid>

			<form className={styles.formContainer} onSubmit={handleSubmit}>
				{error && <div style={{ color: '#d32f2f', marginBottom: 16 }}>{error}</div>}

				<TextField
					label="Time Off Reason Name"
					name="name"
					placeholder="Enter time off reason name"
					value={reason.name}
					onChange={(e) => setReason({ ...reason, name: e.target.value })}
					className={styles.input}
					margin="normal"
					fullWidth
					required
				/>

				<TextField
					label="Description"
					name="description"
					placeholder="Enter description (optional)"
					value={reason.description}
					onChange={(e) => setReason({ ...reason, description: e.target.value })}
					className={styles.input}
					margin="normal"
					fullWidth
					multiline
					rows={3}
				/>

				{/* <FormControlLabel
					control={
						<Checkbox
							checked={reason.isPaid}
							onChange={(e) => setReason({ ...reason, isPaid: e.target.checked })}
							name="isPaid"
						/>
					}
					label="Is Paid Time Off"
					className={styles.checkbox}
				/>

				<FormControlLabel
					control={
						<Checkbox
							checked={reason.requiresApproval}
							onChange={(e) => setReason({ ...reason, requiresApproval: e.target.checked })}
							name="requiresApproval"
						/>
					}
					label="Requires Approval"
					className={styles.checkbox}
				/> */}
			</form>
		</div>
	);
};

export default CreateTimeOffReason;
